import PropTypes from 'prop-types';
import {query} from 'api';
import {Container, Description, TypeLabel, Img} from './styles';
import {colors, fonts} from 'ui/config';
import TextTruncate from 'react-text-truncate';
import {withRouter} from 'react-router';
import {useDragDetection} from 'lib/slider';
import {toAppRoute} from 'lib/siteLinks';

const HomepageRecette = ({history, data, type, id}) => {
  const {handleMouseDown, dragging} = useDragDetection();

  function handleChildClick() {
    if (!dragging) {
      if (type === 'recette_club') {
        history.push(`/recipe/${id}`);
      } else {
        const route = toAppRoute(data.link);
        if (route) history.push(route);
        else window.open(data.link, '_blank');
      }
    }
  }

  if (!data) return null;
  let title;
  let typeLabel;
  let description;
  let imageUrl;
  if (type === 'recette_club') {
    title = data.acf.recette_premiere_partie_titre;
    typeLabel = 'Recette';
    description = data.acf.recette_deuxieme_partie_titre;
    imageUrl = data.acf.recette_image_principale.url;
  } else {
    title = data.title.rendered;
    typeLabel = 'Geste technique';
    description = data.content.rendered;
    imageUrl = data.acf.conseils_image;
  }

  return (
    <Container onMouseDownCapture={handleMouseDown} onClickCapture={handleChildClick}>
      <TypeLabel>{typeLabel}</TypeLabel>
      <Img src={imageUrl} placeholderStyle={{display: 'block'}} />
      <Description>
        <TextTruncate
          style={{
            fontFamily: fonts.title,
            fontWeight: 'bold',
            fontSize: 16,
            lineHeight: '19px',
            marginBottom: 3,
            color: colors.black,
          }}
          text={title}
          line={2}
        />

        <TextTruncate
          style={{
            fontSize: 13,
            color: colors.grey,
          }}
          text={description.replace(/<[^>]*>?/gm, '').replace(/&nbsp;/g, ' ')}
          line={2}
        />
      </Description>
    </Container>
  );
};

HomepageRecette.propTypes = {
  data: PropTypes.object,
  type: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  history: PropTypes.object.isRequired,
};

export default HomepageRecette |> withRouter |> query('getPost');
